import { c as _c } from "react/compiler-runtime";
import * as RadioGroup from '@radix-ui/react-radio-group';
import noop from 'lodash/noop';
import Label from '../label';
import type { GroupedRadioSelectOptionFields, RadioSelectOptionFields } from './components/radio-select-option';
import RadioSelectOption from './components/radio-select-option';
export type RadioSelectProps = {
  label?: string;
  onChange?: (value: string) => void;
  options: RadioSelectOptionFields[] | GroupedRadioSelectOptionFields[];
  size?: 'compact' | 'default';
  testID?: string;
  value?: string;
};
const RadioSelect = t0 => {
  const $ = _c(20);
  const {
    label,
    onChange,
    options,
    size: t1,
    testID,
    value
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== label || $[1] !== size) {
    t2 = label && <Label size={size}>{label}</Label>;
    $[0] = label;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onChange || $[4] !== options || $[5] !== size || $[6] !== value) {
    let t4;
    if ($[8] !== onChange || $[9] !== size || $[10] !== value) {
      t4 = option => {
        if ("label" in option) {
          return <div key={option.label} className="flex flex-col gap-3 not-first:mt-4"><p className="truncate text-secondary text-label-2">{option.label}</p>{option.options.map(subOption => <RadioSelectOption key={subOption.value} value={subOption.value} title={subOption.title} description={subOption.description} IconComponent={subOption.IconComponent} disabled={subOption.disabled} disabledHint={subOption.disabledHint} onClick={subOption.disabled ? noop : () => onChange?.(subOption.value)} selected={subOption.value === value} size={size} />)}</div>;
        }
        return <RadioSelectOption key={option.value} value={option.value} title={option.title} description={option.description} IconComponent={option.IconComponent} disabled={option.disabled} disabledHint={option.disabledHint} onClick={option.disabled ? noop : () => onChange?.(option.value)} selected={option.value === value} size={size} />;
      };
      $[8] = onChange;
      $[9] = size;
      $[10] = value;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = options.map(t4);
    $[3] = onChange;
    $[4] = options;
    $[5] = size;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[12] !== t3 || $[13] !== testID) {
    t4 = <div data-testid={testID} className="flex flex-col gap-2 data-[tooltip-trigger='true']:w-full">{t3}</div>;
    $[12] = t3;
    $[13] = testID;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== onChange || $[16] !== t2 || $[17] !== t4 || $[18] !== value) {
    t5 = <RadioGroup.Root value={value} onValueChange={onChange}>{t2}{t4}</RadioGroup.Root>;
    $[15] = onChange;
    $[16] = t2;
    $[17] = t4;
    $[18] = value;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
export default RadioSelect;